import { useCallback, useEffect, useState } from 'react'
import { UserApi } from '../../../api/user.api'
import { STATE_EXPIRY_TTL } from '../../../Constants'
import StorageService, { StorageKey } from '../../../services/StorageService'

export const useAdministrativeDivisions = isActive => {
  const [isLoadingStates, setIsLoadingStates] = useState(false)
  const [isErrorStates, setIsErrorStates] = useState(false)
  const [administrativeDivisions, setAdministrativeDivisions] = useState([])

  const fetch = useCallback(async () => {
    try {
      let res = {}
      setIsLoadingStates(true)
      if (isActive !== undefined) {
        if (StorageService.getWithExpiry(!isActive ? StorageKey.INACTIVE_STATE_LIST : StorageKey.ACTIVE_STATE_LIST)) {
          res = { parsedData: StorageService.getWithExpiry(!isActive ? StorageKey.INACTIVE_STATE_LIST : StorageKey.ACTIVE_STATE_LIST) }
        } else {
          res = await UserApi.getIsActiveStates(isActive)
          StorageService.setWithExpiry(
            !isActive ? StorageKey.INACTIVE_STATE_LIST : StorageKey.ACTIVE_STATE_LIST,
            res.parsedData,
            STATE_EXPIRY_TTL
          )
        }
      } else {
        if (StorageService.getWithExpiry(StorageKey.STATE_LIST)) {
          res = { parsedData: StorageService.getWithExpiry(StorageKey.STATE_LIST) }
        } else {
          res = await UserApi.getStates()
          StorageService.setWithExpiry(StorageKey.STATE_LIST, res.parsedData, STATE_EXPIRY_TTL)
        }
      }
      setAdministrativeDivisions(res.parsedData)
      setIsLoadingStates(false)
    } catch (error) {
      setIsErrorStates(true)
    }
  }, [isActive])

  useEffect(() => {
    fetch()
  }, [isActive])

  return { isLoadingStates, isErrorStates, administrativeDivisions }
}
